'use strict';

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var parseJson = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response, url, fetchOptions) {
    var responseText;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return response.text();
          case 2:
            responseText = _context.sent;
            _context.prev = 3;
            return _context.abrupt('return', JSON.parse(responseText));
          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](3);
            throw new _errors.ClientError('non_json_response', response, undefined, responseText, url, fetchOptions);
          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 7]]);
  }));
  return function parseJson(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var throwBadStatusError = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(response, ErrorClass, url, fetchOptions) {
    var responseJson, responseText;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            responseJson = void 0;
            _context2.next = 3;
            return response.text();
          case 3:
            responseText = _context2.sent;
            _context2.prev = 4;
            responseJson = JSON.parse(responseText);
          case 6:
            _context2.prev = 6;
            throw new ErrorClass('Unable to retrieve url. Received status: ' + response.status, response, responseJson, responseText, url, fetchOptions);
          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[4,, 6, 9]]);
  }));
  return function throwBadStatusError(_x4, _x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();
exports.fetchUrlWithActions = fetchUrlWithActions;
exports.fetchUrl = fetchUrl;
var _utils = require('./utils');
var _errors = require('./errors');
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
var DEFAULT_FETCH_OPTIONS = {
  credentials: 'same-origin',
  // To include cookies
  method: 'GET',
  headers: {
    'Content-Type': 'application/vnd.api+json',
    'Cache-Control': 'no-cache',
    pragma: 'no-cache'
  }
};
var DEFAULT_FETCH_URL_OPTIONS = {
  shouldParseJson: true,
  logger: false,
  errorLevelMap: _utils.errorToLogLevelMapper
};
function retrieveUrlRequest(type, url) {
  return {
    type: type,
    url: url
  };
}
function retrieveUrlReceive(type, url, payload) {
  return {
    type: type,
    url: url,
    payload: payload
  };
}
function retrieveUrlResponse(type, url, response) {
  return {
    type: type,
    url: url,
    response: response
  };
}
function retrieveUrlError(type, url, error) {
  return {
    type: type,
    url: url,
    error: error
  };
}
function rejectOnBadStatus(response, url, fetchOptions) {
  if (response.status >= 400 && response.status <= 499) {
    return throwBadStatusError(response, _errors.ClientError, url, fetchOptions);
  } else if (response.status < 200 || response.status >= 500) {
    return throwBadStatusError(response, _errors.ServerError, url, fetchOptions);
  }
  return response;
}
function rejectOnNetworkError(url) {
  throw new _errors.NetworkError('Network error while attempting to fetch.', url);
}
function getActions(actions) {
  var defaultActions = {
    request: '__CUSTOMER_REQUEST_FETCH_ACTION__',
    response: '__CUSTOMER_RESPONSE_FETCH_ACTION__',
    receive: '__CUSTOMER_RECEIVE_FETCH_ACTION__',
    error: '__CUSTOMER_ERROR_FETCH_ACTION__'
  };
  if (Array.isArray(actions)) {
    var _actions = _slicedToArray(actions, 3),
      requestAction = _actions[0],
      receiveAction = _actions[1],
      errorAction = _actions[2];
    return {
      request: requestAction,
      response: defaultActions.response,
      receive: receiveAction,
      error: errorAction
    };
  }
  return _extends({}, defaultActions, actions);
}
function fetchUrlWithActions(url, actions) {
  var fetchOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var fetchUrlOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  /*
      Documentation:
      arguments:
          url: url
          actions: redux actions for stages of the request
              request: action on init of request
              response: action on response
              receive: action on response.json()
              error: action on error
          fetchOptions: object of options passed directly to fetch
          fetchUrlOptions: object of options for the function
              logger: logger (if should log on error)
              shouldRejectOnError: boolean if should reject on error, defaults to `false`
              shouldParseJson: boolean. returns parsed json, defaults to `true`. if `false` returns response;
              errorLevelMap: object of error classes to functions that take in an error and return the log level (see `errorToLogLevelMapper` in utils.js for default implementation)
       returns:
          if successful: action object containing `payload`
          if unsuccessful: action object containing `error`
  */
  var _getActions = getActions(actions),
    requestAction = _getActions.request,
    responseAction = _getActions.response,
    receiveAction = _getActions.receive,
    errorAction = _getActions.error;
  var defaultedFetchUrlOptions = _extends({}, DEFAULT_FETCH_URL_OPTIONS, fetchUrlOptions);
  return function (dispatch) {
    dispatch(retrieveUrlRequest(requestAction, url));
    return fetch(url, _extends({}, DEFAULT_FETCH_OPTIONS, fetchOptions)).catch(function () {
      return rejectOnNetworkError(url);
    }).then(function (response) {
      return dispatch(retrieveUrlResponse(responseAction, url, response)).response;
    }).then(function (response) {
      return rejectOnBadStatus(response, url, fetchOptions);
    }).then(function (response) {
      return defaultedFetchUrlOptions.shouldParseJson ? parseJson(response, url, fetchOptions) : response;
    }).then(function (payload) {
      return dispatch(retrieveUrlReceive(receiveAction, url, payload));
    }, function (error) {
      return dispatch(retrieveUrlError(errorAction, url, error));
    }).then(function (value) {
      if (defaultedFetchUrlOptions.logger && value.hasOwnProperty('error')) {
        var error = value.error;
        (0, _utils.logErrorWithMapping)(error, defaultedFetchUrlOptions.errorLevelMap, defaultedFetchUrlOptions.logger);
      }
      return value;
    }).then(function (value) {
      if (defaultedFetchUrlOptions.shouldRejectOnError && value.hasOwnProperty('error')) {
        throw value.error;
      }
      return value;
    });
  };
}
function fetchUrl(url) {
  var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fetchUrlOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  /*
      Unlike fetchUrl, always rejects on error
       arguments:
          url: url
          fetchOptions: object of options passed directly to fetch
          fetchUrlOptions: object of options for the function
              logger: logger (if should log on error)
              shouldParseJson: boolean. returns parsed json, defaults to `true`. if `false` returns response;
              errorLevelMap: object of error classes to functions that take in an error and return the log level (see `errorToLogLevelMapper` in utils.js for default implementation)
      returns:
          if successful: json-parsed response
          if unsuccessful: throws error
  */
  var defaultedFetchUrlOptions = _extends({}, DEFAULT_FETCH_URL_OPTIONS, fetchUrlOptions);
  return fetch(url, _extends({}, DEFAULT_FETCH_OPTIONS, fetchOptions)).catch(function () {
    return rejectOnNetworkError(url);
  }).then(function (response) {
    return rejectOnBadStatus(response, url, fetchOptions);
  }).then(function (response) {
    return defaultedFetchUrlOptions.shouldParseJson ? parseJson(response, url, fetchOptions) : response;
  }).catch(function (error) {
    if (defaultedFetchUrlOptions.logger) {
      (0, _utils.logErrorWithMapping)(error, defaultedFetchUrlOptions.errorLevelMap, defaultedFetchUrlOptions.logger);
    }
    throw error;
  });
}